<template>
  <dl class="socials-list">
    <a
      v-for="link in socials"
      :key="link.name"
      :href="link.link"
      target="_blank"
      rel="noopener noreferrer"
      class="card socials-list__card block"
    >
      <dt>
        <div class="icon-text">
          <img :src="imgLink(link.name)" class="icon-text__img" />
          <h3 class="icon-text__header">{{ link.name }}</h3>
          <img src="/assets/images/icons/link.svg" class="external-link" />
        </div>
      </dt>
      <dl>{{ link.description }}</dl>
    </a>
  </dl>
</template>

<script>
import { Socials } from '@/contents/contents.js'
export default {
  data() {
    return {
      socials: Socials
    }
  },
  methods: {
    imgLink: name =>
      '/assets/images/social-media/' + name.toLowerCase() + '.svg'
  }
}
</script>

<style scoped>
.socials-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(24rem, 1fr));
  font-family: var(--header-font);
  font-size: 1.4rem;
}
.socials-list__card {
  border-width: 0.1rem;
}

.socials-list__card:hover {
  border-bottom-width: 0.2rem;
  border-right-width: 0.2rem;
  box-shadow: none;
}
.icon-text {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: var(--padding-sm);
  position: relative;
}
.icon-text__img {
  width: 1.6rem;
}
.icon-text__header {
  line-height: 1.6rem;
  margin: 0 0.8rem;
}
.external-link {
  width: 1.2rem;
}

@media only screen and (min-width: 600px) {
  .socials-list {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(auto-fit, 1fr);
  }
  .socials-list__card {
    margin: 0 0;
  }
}
</style>
